// Module
var code = "<ul> <li><a href=\"/higher-ed\">Financial Aid &amp; Support</a> </li> <li><a href=\"/lenders\">Lender Tools</a> </li> <li><a href=\"/about\">About Us</a> </li> <li><a href=\"/contact\">Contact Us</a></li> </ul> ";
// Exports
export default code;